export default function PrivacyNotice() {
  return (
    <div style={{ padding: "1.5rem", maxWidth: "900px" }}>
      <h1>Privacy Notice (Draft)</h1>

      <h2>Plain language summary</h2>
      <p>
        This app stores class rosters, seating plans, and behaviour and attendance records so
        teachers can manage classrooms and understand trends. We only collect what we need to
        run the features. Access is restricted to authenticated users, and admin access is
        limited. We do not sell data. You can request changes or deletion by contacting the
        school or the app owner.
      </p>

      <h2>1. Who we are</h2>
      <p>
        This app is operated by Netherthorpe School during the pilot. This notice explains how
        data is handled inside the app during the pilot.
      </p>
      <p>Data controller: Netherthorpe School (Ghamilton@netherthorpe-mlt.co.uk)</p>
      <p>Data processor: Gregory Hamilton (Ghamilton@netherthorpe-mlt.co.uk)</p>

      <h2>2. What data we collect</h2>
      <ul>
        <li>User account data: name, email, and role (teacher/admin)</li>
        <li>Class data: class name, student names, seating plan layout</li>
        <li>Behaviour and objectives: positive/negative events, learning objective achievements</li>
        <li>Attendance: present/absent records by date</li>
        <li>Additional student support data: SEN status/detail and pupil premium indicator (where provided)</li>
        <li>Feedback: bug/idea reports you submit</li>
        <li>Usage analytics: page views and feature usage events</li>
      </ul>

      <h2>3. Why we collect it</h2>
      <ul>
        <li>To provide core classroom management features</li>
        <li>To support teaching and learning, including appropriate classroom support</li>
        <li>To support analytics and reporting</li>
        <li>To improve the app during the pilot</li>
        <li>To provide support and troubleshoot issues</li>
      </ul>

      <h2>4. Legal basis</h2>
      <p>
        The trust processes personal data using one or more lawful bases under data protection
        law. For this pilot, the primary basis is public task (the school's educational function).
        Where applicable, the trust may also rely on legal obligation, contract, vital interests,
        legitimate interests, or consent, as set out in the trust policy.
      </p>

      <h2>5. Who can access the data</h2>
      <ul>
        <li>Teachers can access only their own classes and records</li>
        <li>Admins can access administrative views (feedback, usage analytics)</li>
        <li>System access is restricted to authenticated users and controlled by security rules</li>
      </ul>

      <h2>6. Where data is stored</h2>
      <p>
        Data is stored in Firebase (Google Cloud). Region: europe-west2. Hosting is provided by
        Azure Static Web Apps. Any future MIS integration (e.g., Arbor) would be assessed and
        documented before use.
      </p>

      <h2>7. How long we keep data</h2>
      <p>
        We keep data only as long as needed for the pilot and operational use. See the retention
        policy for specific timelines.
      </p>

      <h2>8. Your rights</h2>
      <p>
        You can request access, correction, or deletion of data by contacting the school or
        project owner by email. We aim to respond within 30 days unless extended under school
        policy.
      </p>

      <h3>8.1 Subject access requests (SARs)</h3>
      <ul>
        <li>Requests can be made in any form, but written requests with contact details and specifics help us respond faster</li>
        <li>Requests are forwarded to the DPO and verified (may require two forms of ID)</li>
        <li>We respond within one month, with a possible extension to three months for complex or numerous requests</li>
        <li>For children, SARs are assessed case by case; pupils aged 12+ are generally considered able to understand their rights</li>
        <li>Requests are logged in the SAR Log (admin-only) to track status and due dates</li>
      </ul>

      <h3>8.2 Sharing and disclosure</h3>
      <ul>
        <li>We do not normally share personal data without consent</li>
        <li>We may share data with agencies, suppliers, or contractors when needed to provide services, under contracts that ensure lawful processing and data minimisation</li>
        <li>We may share data with law enforcement or government bodies where required by law</li>
        <li>We may share data with emergency services or local authorities in emergency situations</li>
      </ul>

      <h2>9. Contact</h2>
      <p>Email: Ghamilton@netherthorpe-mlt.co.uk</p>
      <p>Data protection lead: Gregory Hamilton (Ghamilton@netherthorpe-mlt.co.uk)</p>

      <h2>10. Changes to this notice</h2>
      <p>
        We may update this notice as the pilot evolves. The latest version will be available in
        the project documentation.
      </p>

      <p style={{ marginTop: "1.5rem", fontStyle: "italic" }}>
        Disclaimer: This draft is not legal advice and should be reviewed by the school's data
        protection lead.
      </p>
    </div>
  );
}
